/* CDNA - when a shopper filters a collection by size, push products with none of the
   selected sizes in stock to the end of the grid instead of leaving them mixed in with
   in-stock results. Shopify's native size filter matches any product that offers a
   selected size as an option, regardless of whether that specific variant is in stock,
   so without this a sold-out-in-that-size product can appear ahead of one you can
   actually buy.

   Re-runs on every grid update (filters are applied via AJAX, not a full page reload) via
   a MutationObserver, since the whole <product-list> subtree gets replaced on each filter
   change. A per-list "already sorted for this exact filter signature" guard stops the
   observer from reacting to its own reordering and looping. */
(function () {
  function getActiveSizes() {
    return new URLSearchParams(window.location.search).getAll('filter.v.option.size');
  }

  function sortGrid(list) {
    var activeSizes = getActiveSizes();
    var signature = activeSizes.slice().sort().join(',');

    if (activeSizes.length === 0) {
      delete list.dataset.cdnaSoldOutSorted;
      return;
    }

    if (list.dataset.cdnaSoldOutSorted === signature) return;

    var cards = Array.from(list.children).filter(function (el) {
      return el.tagName === 'PRODUCT-CARD';
    });

    if (cards.length === 0) return;

    var inStock = [];
    var soldOut = [];

    cards.forEach(function (card) {
      if (!card.hasAttribute('sold-out-sizes')) {
        inStock.push(card);
        return;
      }
      var soldOutSizes = card.getAttribute('sold-out-sizes').split('|').filter(Boolean);
      var anyRequestedSizeAvailable = activeSizes.some(function (size) {
        return soldOutSizes.indexOf(size) === -1;
      });
      (anyRequestedSizeAvailable ? inStock : soldOut).push(card);
    });

    list.dataset.cdnaSoldOutSorted = signature;

    if (soldOut.length === 0 || inStock.length === 0) return;

    inStock.concat(soldOut).forEach(function (card) {
      list.appendChild(card);
    });
  }

  function run() {
    document.querySelectorAll('product-list').forEach(sortGrid);
  }

  run();

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
